// extracted by mini-css-extract-plugin
module.exports = {"modal-title":"_38eUIzQzUgCBqWCeeQAzo1","modal-container":"_1y6d9_93nhHMk8KQwvcTAd"};